
import Public from './Public'
import Admin from './Admin'
import Parent from './Parent'
import Accounting from './Accounting'

const layouts = {
    Public, Admin, Parent, Accounting
}

type LayoutName = keyof typeof layouts

export default function Layout(name: LayoutName) {
    return layouts[name]
}